import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/queryClient";
import { saveFullEval } from "@/api/endpoints/maturity";
import type { MaturityEvaluation } from "@/types/maturity";

type SaveFullPayload = {
  responses: Record<string, number>;
  notes: Record<string, string>;
};

export function useSaveMaturityFull(sessionId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ responses, notes }: SaveFullPayload) =>
      saveFullEval(sessionId, responses, notes),
    onMutate: async ({ responses: newResponses, notes: newNotes }) => {
      await queryClient.cancelQueries({
        queryKey: queryKeys.maturity.evaluation(sessionId),
      });
      const previousData = queryClient.getQueryData<MaturityEvaluation>(
        queryKeys.maturity.evaluation(sessionId)
      );
      queryClient.setQueryData<MaturityEvaluation>(
        queryKeys.maturity.evaluation(sessionId),
        (old) =>
          old
            ? { ...old, full_responses: newResponses, full_notes: newNotes }
            : old
      );
      return { previousData };
    },
    onError: (_err, _newData, context) => {
      if (context?.previousData) {
        queryClient.setQueryData(
          queryKeys.maturity.evaluation(sessionId),
          context.previousData
        );
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.maturity.evaluation(sessionId),
      });
    },
  });
}
